// Déclaration des functions 
    import functionsFiltres from '@/functions/filter.js'
    import functionsTris from '@/functions/tris.js'
    import functionsDate from '@/functions/date.js'
    import functions from '@/functions/functions.js'
    import params from '@/param/param.js'
    import { stringify } from 'uuid';
    
    const jours_fr = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
    const alphabetUpper = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    const listeClasse = ['eco', 'aff', 'pre', 'cargo']

    let functionsSpe = {
        ajouterHRSousDernierMot(text) {
            const words = text.split(' ');
            const lastWord = words.pop(); // On prend le dernier mot
            return `${words.join(' ')} <span class="last-word-hr">${lastWord}</span>`; 
        },

        prixBillet(bareme, reglages, date, horaire, type, listeJoursFerie){
            let ferie = false
            var i = 0;
            let result = {
                billet: 0,
                billet_text: "0"
            }

            let j = {}
            let d = 0
            let tableauJourFerier = new Array()
            for(j in listeJoursFerie){
                d++
                tableauJourFerier.push(j)
            }

            

            while(i < d){
                let test = tableauJourFerier[i].split('-');
                let dateJourCompaSplit = date.split('-');
                let dateJourCompaNum = dateJourCompaSplit[0]+dateJourCompaSplit[1]+dateJourCompaSplit[2]
                let dateferieCompa = test[0]+test[1]+test[2];
                if(Number(dateferieCompa) == Number(dateJourCompaNum)){
                    ferie = true;
                }else{
                    ferie = false
                }


                if(ferie !== true){
                    i++;
                }else{
                    i = d
                }
            }
            
            let billet = Number(bareme.tarif_normal.tarif)
            let jour = functionsDate.date(date).jour

            // console.log(billet)
            if(ferie){
                billet += Number(Number(reglages.options.supplement_jour.jour_ferie))
                if(reglages.options.nocturne.heure.replace(':', '') <= horaire.replace(':', '')){
                    billet += Number(reglages.options.nocturne.jour_ferie)
                }
            }else{
                if(reglages.options.nocturne.heure.replace(':', '') <= horaire.replace(':', '')){
                    billet += Number(reglages.options.nocturne[jour.toLowerCase()])
                }

                billet += Number(Number(reglages.options.supplement_jour[jour.toLowerCase()]))
            }

            

            

            
            let reduction = 1
            if(type !== 'tarif_normal'){
                if(bareme[type].unite === '%'){
                    reduction = (100 - Number(bareme[type].tarif)) / 100
                    billet = billet * reduction
                }else if(bareme[type].unite === '€'){
                    reduction = Number(bareme[type].tarif)
                    billet -= reduction
                }
            }
            result.billet = Number(billet)
            result.billet_text = functions.formatDevise(billet)
            // console.log(reduction, result)

            return result
        },

        testEtapes(numero, offre, date, creneau, billets, contact, minBillet, conf){
            if(numero === 1){
                return 'Continuer'
            }
            if(numero >= 2){
                if(numero >= 3){
                    if(numero >= 4){
                        if(numero >= 5){
                            let regexMail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                            let regexTel = /^\d{10}$/
                            if(numero >= 6){
                                if(conf === true){
                                    return 'Envoyer'
                                }
                            }else if(contact.prenom !== '' && contact.nom !== '' && regexMail.test(contact.mail) && regexTel.test(contact.tel)){
                                return 'Continuer'
                            }
                        }else if(billets >= minBillet){
                            return 'Continuer'
                        }
                    }else if(date !== '' && creneau !== ''){
                        return 'Continuer'
                    }
                }else if(offre !== ''){
                    return 'Continuer'
                }
            }
        },

        supplementJours(offre){
            let listeJours = []
            let text = ''
            let cout = new Array()

            params.joursTypes.forEach(j => {
                if((Number(offre.options.supplement_jour[j.toLowerCase()])) !== 0){
                    listeJours.push(j)
                }
            })

            listeJours.forEach((jour, i) => {
                if(i === 0){
                    text = params.joursTypesText[params.joursTypes.indexOf(jour)] + ' : ' + Number(offre.options.supplement_jour[jour.toLowerCase()])
                    cout.push(offre.options.supplement_jour[jour.toLowerCase()])
                }else{
                    // console.log(cout.includes(offre.options.supplement_jour[jour.toLowerCase()]))
                    if(cout.includes(offre.options.supplement_jour[jour.toLowerCase()]) !== -1){
                        text = text.replace(' : ' + offre.options.supplement_jour[jour.toLowerCase()], ', ' + params.joursTypesText[params.joursTypes.indexOf(jour)] + ' : ' + Number(offre.options.supplement_jour[jour.toLowerCase()]))
                    }else{
                        text = text + ', ' + params.joursTypesText[params.joursTypes.indexOf(jour)] + ' : ' + Number(offre.options.supplement_jour[jour.toLowerCase()])
                        cout.push(offre.options.supplement_jour[jour.toLowerCase()])
                    }
                }
            })

            cout.forEach(c => {
                text = text.replaceAll(c, functions.formatDevise(c) + '€')
            })
            return text
        },

        codePromo(montant, reduction){
            let reduc = 0
            montant = montant.replace(',', '.')
            if(reduction === undefined || reduction === null || reduction === '' || montant === undefined || montant === null || montant === ''){
            }else{
                if(reduction.reduction.unite === '%'){
                    reduc = Number(montant) - Number(Number(montant) * ((100 - Number(reduction.reduction.nombre)) / 100))
                }else{
                    reduc = Number(montant) - Number(reduction.reduction.nombre)
                }
            }

            return {
                reduc: reduc, 
                montant: montant - reduc
            }
        }
    }

    export default functionsSpe


// WEBPACK FOOTER //
// ./src/functions/functions_specifiques.js